export const businessNumberTitle = country => {
  switch (country) {
    case 'FR':
      return 'SIRET'
    case 'UK':
      return 'UTR'
    case 'AU':
      return 'ABN'
    default:
      return 'Business Number'
  }
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/Components/ContactDetailsSection/utils.js